module.exports = __webpack_public_path__ + "img/jn-back.a53da2a4.png";